import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  List,
  ListItem,
  Typography,
  styled,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import 'animate.css';
import DrawerItemV2 from "./DrawerItemV2";
import { Link } from "react-router-dom";
import LanguageSelector from "../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

const BASE_PATH = '/peoplefortech/v2';

const NavbarLogo = styled(Box)(({ theme }) => ({
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  backgroundColor: '#000000',
  border: '2px solid #ffffff',
  boxShadow: '0 0 0 2px #000000, 0 2px 6px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.5),
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: { width: '45px', height: '45px' },
}));

const LogoMainText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontWeight: 'bold',
  fontSize: '1rem',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontFamily: '"Montserrat", sans-serif',
  lineHeight: 1,
  [theme.breakpoints.down('sm')]: { fontSize: '0.85rem' },
}));

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const ListMenu = styled(List)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: { display: "flex" },
}));

const NavbarPv2 = () => {
  const { t } = useTranslation();
  const itemList = [
    { text: t("nav.home"), to: BASE_PATH },
    { text: t("v2.booking.cta"), to: `${BASE_PATH}/reserva` },
    { text: t("nav.blog"), to: "/blog" },
    { text: t("nav.contact"), to: `${BASE_PATH}/contact` },
  ];

  return (
    <>
      <style>
        {`
          @keyframes logoFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-8px); }
          }
        `}
      </style>
      <AppBar
        component="nav"
        position="sticky"
        sx={{
          backgroundColor: "white",
          border: "1px solid rgba(0, 0, 0, 0.2)",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          marginBottom: "20px",
        }}
        elevation={0}
      >
        <StyledToolbar>
          <Box
            component={Link}
            to={BASE_PATH}
            sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: 1 }}
          >
            <NavbarLogo>
              <LogoMainText>PXT</LogoMainText>
            </NavbarLogo>
            <Typography
              variant="h6"
              component="h1"
              sx={{
                color: 'black',
                fontWeight: 600,
                fontSize: '1.2rem',
                display: { xs: 'none', sm: 'block' },
              }}
            >
              PeopleForTech
            </Typography>
          </Box>
          <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center", gap: 2 }}>
            <ListMenu>
              {itemList.map((item) => (
                <ListItem key={item.to}>
                  <ListItemButton
                    component={Link}
                    to={item.to}
                    sx={{
                      color: "black",
                      "&:hover": { backgroundColor: "transparent", color: "#1e2a5a" },
                    }}
                  >
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </ListMenu>
            <LanguageSelector />
          </Box>
          <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", gap: 1 }}>
            <LanguageSelector />
            <DrawerItemV2 />
          </Box>
        </StyledToolbar>
      </AppBar>
    </>
  );
};

export default NavbarPv2;
